import { useState } from "react";
import styles from "./styles.module.scss";
import img1 from "./img/1.png";
import img2 from "./img/2.png";
import img3 from "./img/3.png";
import img4 from "./img/4.png";
import img5 from "./img/5.png";
import img6 from "./img/6.png";
import img7 from "./img/7.png";

import { Button } from "@common/index";
import { openModal } from "@utils/modal";
import { Modal } from "./Modal";
import { IconCard, IconCardCheckbox } from "src/routes/onboarding/shared";

const data = [
  {
    value: "I eat late at night",
    displayValue: "I eat late at night",
    emoji: img1,
  },
  {
    value: "I can't quit sugar",
    displayValue: "I can't quit sugar",
    emoji: img2,
  },
  {
    value: "I can't live without soda",
    displayValue: "I can't live without soda",
    emoji: img3,
  },
  {
    value: "I eat too much salt",
    displayValue: "I eat too much salt",
    emoji: img4,
  },
  {
    value: "I drink alcohol",
    displayValue: "I drink alcohol",
    emoji: img5,
  },
  {
    value: "I am a smoker",
    displayValue: "I am a smoker",
    emoji: img6,
  },
];
export const HoldingsBack = ({ onNextStep, onTrackEvent }) => {
  const [checked, setChecked] = useState([]);

  const handleCheck = (value) => {
    setChecked((prevState) => {
      if (prevState.includes(value)) {
        return prevState.filter((item) => item !== value);
      }

      return [...prevState, value];
    });
  };

  const handleNextStep = () => {
    onNextStep?.(checked);
    onTrackEvent?.(checked);
  };

  const handleSelectNone = () => {
    setChecked([]);
    handleNextStep();
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>Any of these holding you back?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardCheckbox
              checked={checked.includes(value.value)}
              onClick={() => handleCheck(value.value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.value}
              variant="walky"
            />
          ))}
          <IconCard title="None of the above" img={img7} onClick={handleSelectNone} walky/>
        </div>
      </div>
      <div className={styles.action}>
        <Button
          variant="walky"
          disabled={!checked.length}
          onClick={handleNextStep}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

